/** 参考本机 Cosoul AgentChatShell 的三档/往返状态机，适配浏览器 Pointer Events。 */
export const MOBILE_CHAT_SNAP_RATIOS = Object.freeze([0.5, 0.8, 1]);
export const MOBILE_CHAT_DEFAULT_SNAP = 1;
export const MOBILE_CHAT_SNAP_DURATION = 240;
export const MOBILE_CHAT_SNAP_EASING = "cubic-bezier(.2,.8,.2,1)";

const clampIndex = (index) =>
  Math.max(
    0,
    Math.min(2, Number.isInteger(index) ? index : MOBILE_CHAT_DEFAULT_SNAP)
  );

export function nextMobileChatSnap(index, direction = 1) {
  const current = clampIndex(index);
  let nextDirection = direction < 0 ? -1 : 1;
  if (current + nextDirection > 2) nextDirection = -1;
  if (current + nextDirection < 0) nextDirection = 1;
  return { index: current + nextDirection, direction: nextDirection };
}

/** 键盘只临时压缩可见区域，不改变用户选定档位；收键盘后恢复。 */
export function mobileChatSheetHeight(
  index,
  viewportHeight,
  baselineHeight = viewportHeight,
  keyboardRaised = false
) {
  if (!Number.isFinite(viewportHeight) || viewportHeight <= 0) return 0;
  const base = keyboardRaised
    ? Math.max(viewportHeight, Number(baselineHeight) || viewportHeight)
    : viewportHeight;
  return Math.round(
    Math.min(viewportHeight, base * MOBILE_CHAT_SNAP_RATIOS[clampIndex(index)])
  );
}

export function mobileChatDragHeight(
  startHeight,
  startY,
  currentY,
  viewportHeight
) {
  return Math.max(
    viewportHeight * MOBILE_CHAT_SNAP_RATIOS[0],
    Math.min(viewportHeight, startHeight + startY - currentY)
  );
}

/** 速度单位px/ms；有限预测使轻扫顺着方向吸附，最小档止于50%，不会误关闭聊天。 */
export function nearestMobileChatSnap(height, viewportHeight, velocity = 0) {
  if (!Number.isFinite(viewportHeight) || viewportHeight <= 0)
    return MOBILE_CHAT_DEFAULT_SNAP;
  const projected =
    height - Math.max(-3, Math.min(3, Number(velocity) || 0)) * 140;
  return MOBILE_CHAT_SNAP_RATIOS.reduce(
    (best, ratio, index, ratios) =>
      Math.abs(ratio * viewportHeight - projected) <
      Math.abs(ratios[best] * viewportHeight - projected)
        ? index
        : best,
    MOBILE_CHAT_DEFAULT_SNAP
  );
}
